module.exports = __webpack_public_path__ + "static/media/salvation-army-small_2x.bc16d8a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/salvation-army-small_2x.png
// module id = 1554
// module chunks = 27